<template>
    <div>
        <Slider />
        <section class="p-10">
            <div class="max-w-6xl mx-auto grid grid-cols-5 gap-8">
                <!-- Left Sidebar -->
                <div class="col-span-1 text-gray-600">
                    <ul class="space-y-4">
                        <li><a href="#" class="block font-semibold hover:text-purple-600">Overview</a></li>
                        <li><a href="#" class="block font-semibold hover:text-purple-600">Admissions</a></li>
                    </ul>
                </div>

                <!-- Main Content -->
                <div class="col-span-4">
                    <!-- University Title and Info -->
                    <h1 class="text-2xl font-bold text-gray-800 ">Lorem Ipsum University</h1>
                    <div class="border-b-2 border-purple w-64 mb-4"></div>
                    <div class="flex items-center space-x-4 mb-6">
                        <button class="bg-purple text-white px-4 py-2 rounded-full hover:bg-purple-700">
                            <i class="far fa-heart mr-2"></i> Save for later
                        </button>
                        <p class="text-gray-600">Lorem Ipsum, UK</p>
                    </div>

                    <!-- University Description -->
                    <p class="text-gray-700 leading-relaxed mb-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor lorem ipsum dolor
                        sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan
                        lacus vel facilisis. Ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur
                        adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </p>

                    <p class="text-gray-700 leading-relaxed mb-6">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor lorem ipsum dolor
                        sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan
                        lacus vel facilisis. Ut labore et dolore magna aliqua.
                    </p>

                    <p class="text-gray-700 leading-relaxed mb-6">
                        Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel
                        facilisis. Ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing
                        elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Slider from '@/components/Slider.vue';
export default {
    name: 'Universities',
    components: {
        Slider,
    },

}
</script>